import { PersistedState } from 'runed';
import { getValueSerializer } from '~/store/valueSerializer';

type Theme = 'light' | 'dark';
export const theme = new PersistedState<Theme>('theme', 'light', {
  serializer: getValueSerializer<Theme>(),
});

export const toggleTheme = () => {
  document.documentElement.classList.toggle('dark-mode');
  document.documentElement.classList.toggle('theme-dark');
  document.documentElement.classList.toggle('theme-light');
  theme.current = document.documentElement.classList.contains('dark-mode')
    ? 'dark'
    : 'light';
};
